var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InfoText',{attrs:{"label":_vm.ELabels.orderNumber}},[_c('router-link',{staticClass:"link-reset v-link hover--main",attrs:{"to":{ name: 'OrderDetails', params: { id: _vm.orderId } }}},[_vm._v(" "+_vm._s(_vm.accountNumber)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }